/** 资源输入：URL 输入框 + 本地文件直传（签名失败降级为 blob URL）。 */
import { useRef, useState } from 'react';
import { Button, Input, Space, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { uploadAsset } from '../../api/client';

interface Props {
  value: string;
  onChange(v: string): void;
  accept: string;
  placeholder?: string;
  preview?: 'image' | 'none';
}

export function AssetInput({ value, onChange, accept, placeholder, preview = 'none' }: Props) {
  const fileRef = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);

  const onFile = async (file: File | undefined) => {
    if (!file) return;
    setUploading(true);
    try {
      const url = await uploadAsset(file);
      onChange(url);
      message.success('上传成功');
    } catch (err) {
      const blob = URL.createObjectURL(file);
      onChange(blob);
      message.warning(`上传服务不可用，已使用本地临时地址（刷新后失效）：${(err as Error).message}`);
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={4}>
      <Space.Compact style={{ width: '100%' }}>
        <Input value={value} placeholder={placeholder ?? '资源地址'} onChange={(e) => onChange(e.target.value)} />
        <Button icon={<UploadOutlined />} loading={uploading} onClick={() => fileRef.current?.click()} />
      </Space.Compact>
      <input ref={fileRef} type="file" accept={accept} hidden onChange={(e) => onFile(e.target.files?.[0])} />
      {preview === 'image' && value && (
        <img src={value} alt="" style={{ maxWidth: '100%', maxHeight: 120, objectFit: 'contain', border: '1px solid #f0f0f0', borderRadius: 4 }} />
      )}
    </Space>
  );
}
